import { useState, useEffect } from "react";
import date from "date-and-time";
import { useSignal } from "@preact/signals-react";

import Screen from "components/Meta/Screen";
import Board from "components/Meta/Board";
import PanelCharts from "./PanelCharts";
import ActiveRooms from "./ActiveRooms";
import Booking from "./Booking";
import ImgPlaya from "./assets/playa.jpg";
import ImgComida from "./assets/comida.jpg";
import { getStorage, setStorage } from "store/local";
import { useStoreProducts } from "./storeProducts";
import proxy from "api/proxy";

function ScreenBooking(props) {
  const view = useSignal("list");
  const ctxView = Booking.ctxView(props.config);
  const [displayOpen, setDisplayMode] = useState(true);
  const [newCtxView, setNewCtxView] = useState(ctxView);
  const [filterDay, setFilterDay] = useState(new Date());
  const [checkData, setCheckData] = useState([]);
  const [occRate, setOccRate] = useState({});
  const [occRoom, setOccRoom] = useState({});
  const { setProducts } = useStoreProducts();
  const localStore = getStorage("ctxSession");
  // const [lastReservations, setLastReservations] = useState([]);
  // const [guestsData, setGuestsData] = useState([]);

  useEffect(() => {
    getBookings();
    getCheckInfo();
    getOccRate();
    setHotelConfig();
    setShop();
    setProducts();
  }, [filterDay]);

  function onChangeDate(value) {
    setFilterDay(value);
  }

  async function getBookings() {
    const filterDayFmt = date.format(filterDay, "YYYY-MM-DD");
    const newDomain = [["lines.arrival_date", "=", filterDayFmt]];
    newCtxView.domain = newDomain;
    setNewCtxView(newCtxView);
  }

  function handleDisplay(mode) {
    setDisplayMode(mode);
  }

  // async function getLastReservations() {
  //   const dom = [];
  //   const order = [["id", "DESC"]];
  //   const limit = 5;
  //   const { data } = await proxy.search(MODEL, dom, fields, limit, order);
  //   setLastReservations(data);
  // }

  async function getCheckInfo() {
    const argsChecks = {
      model: "hotel.folio",
      method: "checks_info",
      args: [{ shop: localStore.shop }],
    };
    const { data: checks } = await proxy.methodCall(argsChecks);
    setCheckData(checks);

    // const argsGuests = {
    //   model: "hotel.folio",
    //   method: "guests_info",
    //   args: [],
    // };
    // const { data: guests } = await proxy.methodCall(argsGuests);
    // setGuestsData(guests);
  }

  async function getOccRate() {
    const argsOcc = {
      model: "hotel.folio",
      method: "occ_rate_info",
      args: [{ shop: localStore.shop }],
    };
    const { data } = await proxy.methodCall(argsOcc);
    setOccRate({
      title: "hotel.chart.occupation_rate",
      elements: [data.occ_rate_today, data.occ_rate_tomorrow],
    });
    setOccRoom({
      title: "hotel.chart.occupation_room",
      elements: [data.occ_room_today, data.occ_room_tomorrow],
    });
  }

  async function setHotelConfig() {
    const hotelConfig = getStorage("hotelConfig");
    if (!hotelConfig) {
      const { data } = await proxy.search(
        "hotel.configuration",
        [],
        [
          "nationality.rec_name",
          "nationality.code",
          "taxes_auth.rec_name",
          "payment_term.name",
        ],
      );
      if (data) {
        setStorage("hotelConfig", data[0]);
      }
    }
  }

  function currentView(viewType) {
    view.value = viewType;
  }

  async function setShop() {
    const ctxSession = getStorage("ctxSession");
    const { shop } = ctxSession;
    // ESTO ES TOTALMENTE INNECESARIO ????
    if (shop) {
      const { data } = await proxy.search(
        "sale.shop",
        ["id", "=", shop],
        ["name"],
      );
      if (data) {
        setStorage("hotelShop", data[0]);
      }
    }
  }

  let styleScreen = "w-full md:w-full lg:w-4/5 xl:w-3/5";
  if (view.value === "list") {
    styleScreen = "w-full md:w-4/5 lg:w-4/5 xl:w-3/5";
  } else {
    styleScreen = "w-full";
  }

  return (
    <div className="flex w-full">
      <Screen style={styleScreen}>
        {view.value === "list" && (
          <PanelCharts
            occRate={occRate}
            checkData={checkData}
            occRoom={occRoom}
          />
        )}
        <div className="flex">
          <Board
            ctxView={newCtxView}
            onChangeDate={onChangeDate}
            currentView={currentView}
          />
          {view.value === "form" && (
            <div className="p-3 w-1/3 h-48">
              <h2 className="text-3xl text-center mt-8 mx-auto text-neutral-700">
                Asistente <span className="font-bold">Frontdesk</span>
              </h2>
              <p className="text-md text-left mt-8 mx-auto text-neutral-500 ">
                Coming soon, you'll find all the relevant information about this
                reservation and your guest. We'll be your copilot. We're on our
                way to becoming leaders in PMS solutions for Colombia and Latin
                America. Are you ready to discover a cutting-edge solution?
              </p>
              <h2 className="text-3xl text-center mt-12 mb-6 mx-auto text-neutral-700">
                Experiencias <span className="font-bold">Inigualables</span>
              </h2>
              <div className="overflow-hidden ">
                <img className="rounded-2xl w-full px-2 pt-2" src={ImgPlaya} />
                <img className="rounded-2xl w-full px-2 pt-2" src={ImgComida} />
              </div>
            </div>
          )}
        </div>
      </Screen>
      {view.value === "list" && <ActiveRooms />}
    </div>
  );
}

export default ScreenBooking;
